/* Posity — favorieten. Eén bron voor de hele site.
   Handoff "Favorieten" (28 juli 2026), §1 Opslag. De kern hieronder is letterlijk
   de code uit de handoff; alles daaronder is de UI-bedrading (hartjes + tellers).

   Geladen in layout/theme.liquid met defer, vóór de secties. Klassiek script met
   een global — GEEN ES-module: header, lade, productkaart, PDP en de
   favorietenpagina lezen hem alle vijf. Een bare `export` gooit hier
   "Unexpected token 'export'" en breekt daarmee het hartje op élke pagina.

   Geen account, geen customer-metafield, geen netwerkverzoek: favorieten zijn
   lokaal. Samenvoegen bij inloggen is expliciet buiten scope (handoff §1).

   TWEE VALKUILEN die dit stuk in de praktijk slopen:
   - iOS privémodus gooit een fout op localStorage.setItem in plaats van stil te
     falen → alles in try/catch, anders breekt het hartje de pagina.
   - Safari wist localStorage na zeven dagen zonder bezoek. Browserbeperking,
     geen reden om een serveroplossing te bouwen.

   HANDLE-CACHE (aanvulling op de handoff, bewust):
   De lijst houdt variant-id's — dat is de identiteit, want een handle verandert
   bij hernoemen. Maar een thema kán uit een variant-id géén product opvragen:
   zowel /products/<handle>.js als de Section Rendering API willen een handle.
   Daarom staat naast de lijst een aparte cache-sleutel posity:favs:h met
   {variant-id: handle}. Die is puur een lookup-hulp en nooit de identiteit:
   raakt hij kwijt of wijst hij naar een verdwenen product, dan valt dat item
   stil uit de lijst volgens de regel "verdwenen product" (handoff §2).
*/
(function () {
  var KEY = 'posity:favs';
  var HKEY = 'posity:favs:h';
  var MAX = 100;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var d = JSON.parse(raw);
      return Array.isArray(d && d.ids) ? d.ids.filter(Number.isInteger) : [];
    } catch (e) {
      return []; // corrupt of geblokkeerd → lege lijst, geen crash
    }
  }

  function readHandles() {
    try {
      var raw = localStorage.getItem(HKEY);
      if (!raw) return {};
      var d = JSON.parse(raw);
      return d && typeof d === 'object' ? d : {};
    } catch (e) {
      return {};
    }
  }

  function write(ids) {
    var kept = ids.slice(-MAX);
    try {
      localStorage.setItem(KEY, JSON.stringify({ v: 1, ids: kept }));
      // Handle-cache meesnoeien: nooit groter dan de lijst zelf.
      var all = readHandles();
      var pruned = {};
      for (var i = 0; i < kept.length; i++) {
        if (all[kept[i]]) pruned[kept[i]] = all[kept[i]];
      }
      localStorage.setItem(HKEY, JSON.stringify(pruned));
    } catch (e) {} // privémodus iOS: negeren, niet crashen
    document.dispatchEvent(new CustomEvent('posity:favs', { detail: kept }));
  }

  function rememberHandle(id, handle) {
    if (!handle) return;
    try {
      var all = readHandles();
      all[id] = handle;
      localStorage.setItem(HKEY, JSON.stringify(all));
    } catch (e) {}
  }

  window.PosityFavs = {
    all: function () {
      return read();
    },
    has: function (id) {
      return read().indexOf(Number(id)) !== -1;
    },
    count: function () {
      return read().length;
    },
    handle: function (id) {
      return readHandles()[Number(id)] || null;
    },
    toggle: function (id, handle) {
      id = Number(id);
      if (!id) return false;
      var ids = read();
      var i = ids.indexOf(id);
      if (i === -1) {
        ids.push(id);
        rememberHandle(id, handle);
      } else {
        ids.splice(i, 1);
      }
      write(ids);
      return i === -1; // true = toegevoegd
    },
    add: function (id, handle) {
      id = Number(id);
      if (!id) return;
      var ids = read();
      if (ids.indexOf(id) === -1) {
        ids.push(id);
        rememberHandle(id, handle);
        write(ids);
      }
    },
    // Stil verwijderen: variant bestaat niet meer, of undo-venster verlopen.
    forget: function (id) {
      id = Number(id);
      var ids = read();
      var i = ids.indexOf(id);
      if (i === -1) return;
      ids.splice(i, 1);
      write(ids);
    },
  };

  // Tweede tabblad houdt gelijke stand — zonder dit overschrijft het ene het andere.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      document.dispatchEvent(new CustomEvent('posity:favs', { detail: read() }));
    }
  });

  /* ---- UI-bedrading -----------------------------------------------------
     Alles wat favorieten toont luistert naar hetzelfde event en leest deze
     module. Nooit een tweede telling (handoff §1, rij "teller").

     Hartje: <button class="prod-fav" data-posity-fav data-fav-id="…" data-fav-handle="…">
     Teller: elk element met [data-posity-fav-count]; verbergt zichzelf bij 0.

     De begintoestand staat NIET in Liquid — die verschilt per bezoeker en zou de
     paginacache breken. De kaart rendert altijd een leeg hart; deze module kleurt
     hem direct na het laden bij (handoff §5, "optimistisch bijwerken").
  */

  function btnId(btn) {
    // PDP: de gekozen variant verandert zonder herladen, dus lees het formulier
    // op het moment zelf in plaats van een vastgezet id in het attribuut.
    if (btn.hasAttribute('data-fav-live')) {
      var input = document.querySelector('.posity-pdp__form [name="id"]');
      if (input && input.value) return Number(input.value);
    }
    return Number(btn.getAttribute('data-fav-id'));
  }

  function paint(btn) {
    var on = window.PosityFavs.has(btnId(btn));
    btn.classList.toggle('on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Verwijder uit favorieten' : 'Bewaar als favoriet');
  }

  function sync() {
    var btns = document.querySelectorAll('[data-posity-fav]');
    for (var i = 0; i < btns.length; i++) paint(btns[i]);

    var n = window.PosityFavs.count();
    var label = n > 99 ? '99+' : String(n);
    var counters = document.querySelectorAll('[data-posity-fav-count]');
    for (var j = 0; j < counters.length; j++) {
      counters[j].textContent = label;
      counters[j].hidden = n === 0; // teller alleen bij ≥ 1 (handoff §6)
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-posity-fav]') : null;
    if (!btn) return;
    // De kaart is één grote link: het hartje mag die klik niet volgen.
    e.preventDefault();
    e.stopPropagation();
    var id = btnId(btn);
    if (!id) return;
    var wasOn = window.PosityFavs.has(id);
    window.PosityFavs.toggle(id, btn.getAttribute('data-fav-handle'));
    paint(btn); // optimistisch: geen netwerkverzoek om op te wachten
    meet(btn, wasOn);
  });

  /* Meting — Microsoft Clarity, zelfde patroon als de video-events in
     sections/posity-pdp.liquid: een custom tag om op te filteren plus een leesbare
     eventnaam. De tag staat al in snippets/posity-clarity.liquid en definieert
     window.clarity meteen als wachtrij, dus dit werkt ook voor de tag zelf binnen is.

     Bewust HIER en niet in de PDP-sectie: dit is de enige plek waar élke klik op een
     hartje langskomt (PDP, productkaart, lade, favorietenpagina). Eén meetpunt, net
     zoals er ook maar één opslag is.

     Bewust GEEN de-duplicatie per sessie zoals bij de video: aan- en uitzetten is
     precies het gedrag dat we willen zien, dus elke klik telt. Wel gescheiden events
     voor toevoegen en verwijderen — anders lees je een twijfelaar als twee fans.

     Geen bibliotheek toegevoegd, geen netwerkverzoek van onszelf, en alles in een
     try/catch: een meting mag het hartje nooit breken. */
  function meet(btn, wasOn) {
    try {
      var naam = wasOn ? 'fav_remove' : 'fav_add';
      var handle = btn.getAttribute('data-fav-handle') || 'onbekend';
      // Waar werd geklikt. Nuttiger dan het totaal: het hartje op de PDP is een
      // andere beslissing dan het hartje op een kaart in een rail.
      var bron = btn.classList.contains('posity-pdp__fav') ? 'pdp' : 'kaart';
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'fav_product', handle);
        window.clarity('set', 'fav_bron', bron);
        window.clarity('event', naam);
        window.clarity('event', naam + ':' + bron);
      }
      // GA4 alleen als het er al staat — geen bibliotheek toevoegen.
      if (typeof window.gtag === 'function') {
        window.gtag('event', naam, { product_handle: handle, bron: bron });
      }
    } catch (e) {
      /* meting mag nooit de knop breken */
    }
  }

  document.addEventListener('posity:favs', sync);
  // PDP-variantwissel: het formulier krijgt een nieuw id zonder herladen.
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.posity-pdp')) setTimeout(sync, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
